import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 1. Importações do Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css' // Importa os ícones

// 2. Definição do tema (opcional, pode ser movido para um arquivo separado)
const myCustomLightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#6200EE',
    'primary-darken-1': '#3700B3',
    secondary: '#03DAC6',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
}

const myCustomDarkTheme = {
    dark: true,
    colors: {
        background: '#121212',
        surface: '#121212',
        primary: '#BB86FC',
        secondary: '#03DAC5',
    }
}


// 3. Criação da instância do Vuetify
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi', // Define o MDI como pacote de ícones padrão
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: myCustomLightTheme,
      dark: myCustomDarkTheme,
    },
  },
})

// 4. Criação e montagem da App
createApp(App)
  .use(router)
  .use(vuetify) // Usa o Vuetify
  .mount('#app')